import React, { useRef, useState } from 'react';
import { UserOutlined } from '@ant-design/icons';
import ChevronDownIcon from '@assets/icons/chevron-down.svg';
import ChevronUpIcon from '@assets/icons/chevron-up.svg';
import NotificationIcon from '@assets/notification_icon.svg';
import { BaseDropdown } from '@components/dropdown';
import { useCustomNavigate } from '@hooks/useCustomNavigate.ts';
import { DATA_FINAL_QUIZ_DISABLE } from '@hooks/useFinalQuizAbortGuard.ts';
import { ROUTES } from '@router/constants.ts';
import { AvatarImg } from '@routes/profile-bar/___shared___/components/avatar';
import BlueBytePoints from '@routes/profile-bar/ui/blue-byte-points';

import {
    Avatar,
    AvatarWrapper,
    ContentWrapper,
    Info,
    NotificationCount,
    NotificationWrapper,
    ProfileBarWrapper,
} from './styled.tsx';
import { Name, Role } from './ui/___shared___/styled.tsx';
import ProfileMenu from './ui/profile-menu';

interface Props {
    name: string;
    role: string;
    notificationCount: number;
    avatarUrl: string;
    score: number;
}

const SCENARIO_3_ROUTE = ROUTES.PROFILE_BAR.USER_NOTIFICATIONS;

const isAboveTwoDigits = (notificationCount: number) => notificationCount >= 100;

const ProfileBar: React.FC<Props> = ({ name, role, notificationCount, avatarUrl, score }) => {
    const [isMenuOpened, setIsMenuOpened] = useState(false);
    const navigate = useCustomNavigate();
    const containerRef = useRef<HTMLDivElement>(null);

    return (
        <ProfileBarWrapper ref={containerRef}>
            <ContentWrapper>
                <Info>
                    <Name>{name}</Name>
                    <Role>{role}</Role>
                </Info>
                <BlueBytePoints score={score} />
                <NotificationWrapper onClick={() => navigate(SCENARIO_3_ROUTE)} {...DATA_FINAL_QUIZ_DISABLE}>
                    <NotificationIcon />
                    {notificationCount > 0 && (
                        <NotificationCount>
                            {isAboveTwoDigits(notificationCount) ? '99+' : notificationCount}
                        </NotificationCount>
                    )}
                </NotificationWrapper>

                <BaseDropdown
                    trigger={['click']}
                    placement="bottomLeft"
                    open={isMenuOpened}
                    onOpenChange={setIsMenuOpened}
                    classNames={{ root: 'profile-bar-profile-menu-dropdown' }}
                    align={{ offset: [0, 40] }}
                    popupRender={() => (
                        <ProfileMenu
                            avatarUrl={avatarUrl}
                            name={name}
                            role={role}
                            closeMenu={() => setIsMenuOpened(false)}
                        />
                    )}
                >
                    <AvatarWrapper data-cy="profile-bar" {...DATA_FINAL_QUIZ_DISABLE}>
                        <Avatar>{avatarUrl ? <AvatarImg avatarURI={avatarUrl} /> : <UserOutlined />}</Avatar>
                        {isMenuOpened ? <ChevronUpIcon /> : <ChevronDownIcon />}
                    </AvatarWrapper>
                </BaseDropdown>
            </ContentWrapper>
        </ProfileBarWrapper>
    );
};

export default ProfileBar;
